import { set, del } from "idb-keyval"
import { recordEvent } from "../apis/googleAnalytics"

function checkReadPlanMark(
  readPlan,
  setReadPlan,
  readPlanID,
  setReadPlanID,
  language,
  version,
  id
) {
  if (readPlan[`readingPlan-${language}-${version}-${id}`] === true) {
    const newReadObj = Object.assign(readPlan, {
      [`readingPlan-${language}-${version}-${id}`]: false,
    })
    setReadPlan(newReadObj)
    setReadPlanID(readPlanID + 1)
  } else {
    const newReadObj = Object.assign(readPlan, {
      [`readingPlan-${language}-${version}-${id}`]: true,
    })
    setReadPlan(newReadObj)
    setReadPlanID(readPlanID + 1)
  }
}

export function checkReadMark(
  read,
  updateRead,
  readPlan,
  setReadPlan,
  readPlanID,
  setReadPlanID,
  language,
  version,
  id
) {
  const rpKey = `readingPlan-${language}-${version}-${id}`
  if (read) {
    del(rpKey)
    checkReadPlanMark(
      readPlan,
      setReadPlan,
      readPlanID,
      setReadPlanID,
      language,
      version,
      id
    )
    updateRead(false)
  } else {
    recordEvent(
      "Read CheckMark",
      `${language}-${version}`,
      id
    )
    set(rpKey, true)
    checkReadPlanMark(
      readPlan,
      setReadPlan,
      readPlanID,
      setReadPlanID,
      language,
      version,
      id
    )
    updateRead(true)
  }
}
